export interface MenuItem {
    id: string;
    title: string;
    url: string;
    subItems: MenuItem[];
    roles: string[];
}
